import React from 'react';
import "./styles.css";

export const FocusingComponentV2 = () => (
	<React.Fragment>
        <div class="Focusouter">
            <div class="title">
                <div class="focusSubTitle">
                    Cool things that I'm focusing
                </div>
                <div class="focusingSubContent">
                    I value and mingle things from different disciplinaries taking risks, pushing boundaries and having fun!
                </div>
            </div>
            <div class="FocusMain">
                <div className='focusCard'>
                    <img className="focusCardImage" src={process.env.PUBLIC_URL+ "/img/sports.png"}/>
                    <div className='focusCardTitle'>
                        Sports 
                    </div>
                    <div className='focusCardText'>
                    I enjoy playing and learning new sports during my lesiure time and had master many sports including: 
				tennis, fencing, football, basketball, volleyball, badminton, table tennis and swimming. My love for sports 
                makes me passionate about my research and implementing new innovative sports technologies.
                    </div>
                    <div className='hashTag'>
                        #SportsAnalysis #HumanPoseEstimation #ActionRecognition #HumanTracking
                    </div>
                </div>
                <div className='focusCard'>
                    <img className="focusCardImage" src={process.env.PUBLIC_URL+ "/img/self-learning.png"}/>
                    <div className='focusCardTitle'>
                        Technologies
                    </div>
                    <div className='focusCardText'>
                    I love exploring new technologies. During the third semester of my undergraduate, I started exploring new programming languages and came across ReactJS, which 
                    was not really popular back then. Right now I am fluent in many languages and enjoy building side projects during my free time.
                    </div>
                    <div className='hashTag'>
                        #C #Cpp #CSharp #Java #Python #Javascript #ReactJS #NodeJS
                    </div>
                </div>
                <div className='focusCard'>
                    <img className="focusCardImage" src={process.env.PUBLIC_URL+ "/img/camera.jpg"}/>
                    <div className='focusCardTitle'>
                        Art & Creativities
                    </div>
                    <div className='focusCardText'>
                        My passion for art started since I was young. I was able to build my own remote control cars with the enjoyment of learning 
                        about car components like car suspension at the age of 8. I also enjoy drawing sketches and oil paint during my spare time. Currently, I am learning about graphics design.
                    </div>
                    <div className='hashTag'>
                        #GraphicsDesgin #Illustrator #Photoshop 
                    </div>
                </div>
                
            </div>
        </div>
        
	</React.Fragment>
);